import { auditHistoryApi } from "@/services/api/auditHistory.api";
import appSnackbarService from "@/services/appSnackbar.service";
import i18n from "@/services/i18n";

interface AuditHistoryRequest {
  page: number;
  rowsPerPage: number;
  sortBy?: string;
  descending?: boolean;
  searchString?: string;
  entityType?: string;
  entityId?: number;
  fromDate?: string;
  toDate?: string;
  changedBy?: string;
  action?: string;
}

export const auditHistoryState: any = {
  namespaced: false,
  state: {
    history: [],
    selectedAuditHistory: null,
    totalItem: 0,
    total: 0,
    loading: true,
    fetching: false,
    error: null
  },
  mutations: {
    // fetch audit histories
    AUDIT_HISTORY_FETCH_SUCCESS(state: any, payload: any) {
      state.history = payload.data;
      state.total = payload.data.length;
      state.totalItem = payload.totalCount;
      state.loading = false;
      state.fetching = false;
      state.error = null;
    },
    AUDIT_HISTORY_FETCH_START(state: any) {
      state.fetching = true;
      state.loading = true;
    },
    AUDIT_HISTORY_FETCH_ERROR(state: any, payload: any) {
      state.fetching = false;
      state.loading = false;
      state.error = payload;
    },

    // fetch audit history detail
    AUDIT_HISTORY_DETAIL_SUCCESS(state: any, payload: any) {
      state.selectedAuditHistory = payload;
      state.loading = false;
      state.fetching = false;
      state.error = null;
    },
    AUDIT_HISTORY_DETAIL_START(state: any) {
      state.fetching = true;
      state.loading = true;
    },
    AUDIT_HISTORY_DETAIL_ERROR(state: any, payload: any) {
      state.fetching = false;
      state.loading = false;
      state.error = payload;
    },

    // clear selected audit history
    AUDIT_HISTORY_CLEAR_SELECTED(state: any) {
      state.selectedAuditHistory = null;
    }
  },
  actions: {
    getAuditHistories({ commit }: any, request: AuditHistoryRequest) {
      const promise = new Promise((resolve, reject) => {
        commit("AUDIT_HISTORY_FETCH_START");
        auditHistoryApi
          .getAuditHistory(request)
          .then(response => {
            commit("AUDIT_HISTORY_FETCH_SUCCESS", response.data);
            resolve(response);
          })
          .catch(error => {
            commit("AUDIT_HISTORY_FETCH_ERROR", error);
            reject(error);
          });
      });
      return promise;
    },
    getAuditHistoryDetail({ commit }: any, id: number) {
      const promise = new Promise((resolve, reject) => {
        commit("AUDIT_HISTORY_DETAIL_START");
        auditHistoryApi
          .getAuditHistoryDetail(id)
          .then(response => {
            commit("AUDIT_HISTORY_DETAIL_SUCCESS", response.data);
            resolve(response);
          })
          .catch(error => {
            commit("AUDIT_HISTORY_DETAIL_ERROR", error);
            reject(error);
          });
      });
      return promise;
    },
    getEntityHistory({ commit }: any, payload: { entityType: string; entityId: number }) {
      const promise = new Promise((resolve, reject) => {
        commit("AUDIT_HISTORY_FETCH_START");
        auditHistoryApi
          .getEntityHistory(payload.entityType, payload.entityId)
          .then(response => {
            commit("AUDIT_HISTORY_FETCH_SUCCESS", response.data);
            resolve(response);
          })
          .catch(error => {
            commit("AUDIT_HISTORY_FETCH_ERROR", error);
            reject(error);
          });
      });
      return promise;
    },
    clearSelectedAuditHistory({ commit }: any) {
      commit("AUDIT_HISTORY_CLEAR_SELECTED");
    }
  }
};
